class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.quickBuyBox = document.querySelector('quickbuy-box');

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
   
  }

  open() {
    this.notification.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden-mobile');
    this.quickBuyBox && this.quickBuyBox.classList.add('hidden');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
      this.header.classList.add('small-hide');
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.classList.remove('overflow-hidden-mobile');
    this.quickBuyBox && this.quickBuyBox.classList.remove('hidden');
    this.header.classList.remove('small-hide');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, quiet=false) {
    this.productId = parsedState.id || parsedState.items[0].id
    this.getSectionsToRender().forEach((section => {
      document.getElementById(section.id).innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    parsedState.items.forEach(item => {
      const itemEl = document.querySelector(`#cart-notification-product-${item.id}`);
      if (itemEl) {
        setTimeout(() => itemEl.classList.add('new'), 300);
        setTimeout(() => itemEl.classList.remove('new'), 3000);
      }
      if (itemEl.querySelector(".cart-notification-product__quantity").dataset.quantity != item.quantity) {
        console.log("test");
        const quantityLimitItem = itemEl.querySelector('.cart-notification-product__quantity_limited');
        setTimeout(() => quantityLimitItem.classList.add("active"), 300);
        setTimeout(() => quantityLimitItem.classList.remove('active'), 10000);
      }
      if(itemEl){
        const itemUpsellEl = document.querySelector(`#cart-notification-product-${item.id}-upsell`);
        if(itemUpsellEl){
            itemUpsellEl.classList.remove("hidden");
            itemUpsellEl.previousElementSibling.classList.remove("hidden");
            itemUpsellEl.querySelector(".upsell-btn").addEventListener("click", () => {
              this.upsellProduct(itemUpsellEl.dataset.productId)
            })
        }                          
      }
    });
    
    if(quiet){ 
      return; 
    }
    
    if (this.header) {
      if (window.innerWidth > 750) {
        this.header.reveal();
      } else {
        this.header.hide();
      }
    }
    this.open();
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-title' },
      { id: 'cart-notification-product' },
      { id: 'cart-notification-totals' },
      { id: 'cart-icon-bubble' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  upsellProduct(id){
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const sections = this.getSectionsToRender().map((section) => section.id);
      const sections_url = window.location.pathname;
      const body = {
        items: [
          {id: id, quantity: 1}
        ],
        sections,
        sections_url,
      }
   
      config.body = JSON.stringify(body);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          this.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
  }
}

customElements.define('cart-notification', CartNotification);
